import React from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import OfferCardItem from '@components/Offer/OfferCardItem';
import OfferCardControls from '@components/Offer/OfferCardControls';

const OfferCard = ({
  offerSettings,
  offer,
  onRequestOfferAccess,
  onRefuseOfferAccess,
  onFlowCreate,
  editFlow,
}) => {
  return (
    <div className="offer-card">
      <div className="offer-card-inner">
        <Row>
          <Col md="2">
            <img
              className="rounded-circle"
              src={`${offerSettings['images_path']}${offer.images ? offer.images[100] : ''}?1`}
              alt=""
            />
          </Col>
          <Col md="10">
            <div className="offer-card-title">
              <h3 className="offer-title">{offer.title}</h3>
            </div>

            {offer.description && (
              <OfferCardItem
                id="offer.overview"
                className="offer-overview"
                defaultMessage="Overview"
                html={offer.description}
              />
            )}

            {offer.full_description && (
              <OfferCardItem
                id="offer.description"
                defaultMessage="Description"
                className="offer-description"
                html={offer.full_description}
              />
            )}

            {offer.rules && (
              <OfferCardItem
                id="offer.rules"
                className="offer-rules"
                defaultMessage="Offer's Rules"
                html={offer.rules}
              />
            )}
          </Col>
        </Row>
      </div>

      {!editFlow && (
        <OfferCardControls
          theme={4}
          offerId={offer.id}
          isMy={offer.modifies.is_my}
          hasAccess={offer.admit.has_access}
          hasPromo={offer.hasPromo}
          onRequestOfferAccess={onRequestOfferAccess}
          onRefuseOfferAccess={onRefuseOfferAccess}
          onFlowCreate={onFlowCreate}
        />
      )}
    </div>
  );
};

export default OfferCard;
